import { render } from "./IconSprite.vue?vue&type=template&id=dae3b5a6"
import script from "./IconSprite.vue?vue&type=script&lang=js"
export * from "./IconSprite.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__